import gql from "graphql-tag";
import * as moment from "moment";
import {GqlModel, GqlModelListOperator} from "../graphql/graphql.model";
import {jsonProperty} from "../json.model";

export class NotificationsGqlModel extends GqlModel {
  static mapper: GqlModelListOperator<NotificationsGqlModel> =
    GqlModel.buildListMapper(NotificationsGqlModel, "notifications");

  static properties = [
    "projectId",
    "projectName",
    "workflowId",
    "targetType",
    "targetVersion",
    "targetId",
    "readableTargetType",
    "targetName",
    "step",
    "readableStepName",
    {key: "lastUpdate", action: "date"},
    "lastUpdateName",
    "lastUpdateEmail",
    "status",
    "statusString",
    "roles",
    "url",
  ];

  static query = gql`
    subscription notifications {
      notifications {
        projectId
        projectName
        workflowId
        targetType
        targetVersion
        targetId
        readableTargetType
        targetName
        step
        readableStepName
        lastUpdate
        lastUpdateName
        lastUpdateEmail
        status
        roles
        url
      }
    }
  `;

  @jsonProperty("string") projectId: string;
  @jsonProperty("string") projectName: string;
  @jsonProperty("string") workflowId: string;
  @jsonProperty("string") targetType: string;
  @jsonProperty("number0") targetVersion: number;
  @jsonProperty("string") targetId: string;
  @jsonProperty("string") readableTargetType: string;
  @jsonProperty("string") targetName: string;
  @jsonProperty("string") step: string;
  @jsonProperty("string") readableStepName: string;
  @jsonProperty("date") lastUpdate: Date;
  @jsonProperty("string") lastUpdateName: string;
  @jsonProperty("string") lastUpdateEmail: string;
  @jsonProperty("number0") status: number;
  @jsonProperty(NotificationsGqlModel.getStatusString) statusString: string;
  @jsonProperty(["string"]) roles: string[];
  @jsonProperty("string") url: string;

  static getStatusString(value: any, data: any, instance: NotificationsGqlModel) {
    const time = instance.lastUpdate ? moment.utc(instance.lastUpdate).format("YYYY-MM-DD hh:mm:ss A") : undefined;

    if (instance.lastUpdateName && time) {
      return `by ${instance.lastUpdateName} at ${time}`;
    }

    if (instance.lastUpdateName) {
      return `by ${instance.lastUpdateName}`;
    }

    if (time) {
      return `at ${time}`;
    }

    return "";
  }
}
